import { useI18n } from '@runtime/core/i18n/i18n'
import { primaryPlayNavigation, secondaryPlayNavigation } from './playNavigationDestinations'
import styles from './PlayNavigation.module.scss'
import PlayNavigationItem from './PlayNavigationItem'

export default function PlayNavigation({
  mobile = false,
  onNavigate,
}: {
  mobile?: boolean
  onNavigate?: () => void
}) {
  const { t } = useI18n()
  const renderItems = (items: typeof primaryPlayNavigation | typeof secondaryPlayNavigation) =>
    items
      .filter(item => item.id !== 'hub')
      .map(item => (
        <PlayNavigationItem key={item.id} item={item} mobile={mobile} onNavigate={onNavigate} />
      ))

  return (
    <nav
      className={[styles.navigation, mobile ? styles.mobile : styles.desktop].join(' ')}
      aria-label={t('common.playNavigation.label')}
      data-testid={mobile ? 'play-mobile-navigation' : 'play-sidebar'}
    >
      <ul className={styles.primary} data-testid="play-primary-navigation">
        {renderItems(primaryPlayNavigation)}
      </ul>
      <ul className={styles.secondary}>{renderItems(secondaryPlayNavigation)}</ul>
    </nav>
  )
}
